import { useState } from 'react';
import { Box, Typography, Container } from '@mui/material';
import Grid from '@mui/material/Grid';

const caseStudies = [
    {
        id: 1,
        image: '/images/home/89bd0592417f86f5c86293a8c83dbf7850708dc7.png',
        client: 'Mid-sized real estate brokerage firm in USA',
        results: [
            {
                title: '60% increase in lead engagement',
                description: 'Leads spent more time on the website interacting with the AI chatbot, providing their requirements and basic deal information through conversational AI interface.'
            },
            {
                title: '35% higher conversion rates',
                description: 'Users engaging with the 24/7 AI assistant were more likely to book a call, thanks to the personalized digital clone experience.'
            },
            {
                title: '50% time savings',
                description: 'Sales agents reduced their time spent on repetitive inquiries and follow-ups, focusing on closing deals instead while the virtual agent handled initial customer service.'
            },
            {
                title: '90% Advertisement/SPAM inquiries filtered',
                description: 'Lead quality increased dramatically with human-like text chat filtering, reducing necessity to use other tools for spam detection through AI agentic system.'
            },
            {
                title: 'Native Salesforce Sales Cloud integration',
                description: 'The AI agent builder solution integrated seamlessly with existing Salesforce CRM as a Salesforce bot, enabling both internal sales agents and customers to get personalized recommendations via preferred channels (text messages, emails or interactive voice/text conversation).'
            }
        ]
    },
    {
        id: 2,
        image: '/images/home/89bd0592417f86f5c86293a8c83dbf7850708dc7.png',
        client: 'Mid-sized real estate brokerage firm in USA',
        results: [
            {
                title: '60% increase in lead engagement',
                description: 'Leads spent more time on the website interacting with the AI chatbot, providing their requirements and basic deal information through conversational AI interface.'
            },
            {
                title: '35% higher conversion rates',
                description: 'Users engaging with the 24/7 AI assistant were more likely to book a call, thanks to the personalized digital clone experience.'
            },
            {
                title: '50% time savings',
                description: 'Sales agents reduced their time spent on repetitive inquiries and follow-ups, focusing on closing deals instead while the virtual agent handled initial customer service.'
            },
            {
                title: '90% Advertisement/SPAM inquiries filtered',
                description: 'Lead quality increased dramatically with human-like text chat filtering, reducing necessity to use other tools for spam detection through AI agentic system.'
            },
            {
                title: 'Native Salesforce Sales Cloud integration',
                description: 'The AI agent builder solution integrated seamlessly with existing Salesforce CRM as a Salesforce bot, enabling both internal sales agents and customers to get personalized recommendations via preferred channels (text messages, emails or interactive voice/text conversation).'
            }
        ]
    },
    {
        id: 3,
        image: '/images/home/89bd0592417f86f5c86293a8c83dbf7850708dc7.png',
        client: 'Mid-sized real estate brokerage firm in USA',
        results: [
            {
                title: '60% increase in lead engagement',
                description: 'Leads spent more time on the website interacting with the AI chatbot, providing their requirements and basic deal information through conversational AI interface.'
            },
            {
                title: '35% higher conversion rates',
                description: 'Users engaging with the 24/7 AI assistant were more likely to book a call, thanks to the personalized digital clone experience.'
            },
            {
                title: '50% time savings',
                description: 'Sales agents reduced their time spent on repetitive inquiries and follow-ups, focusing on closing deals instead while the virtual agent handled initial customer service.'
            },
            {
                title: '90% Advertisement/SPAM inquiries filtered',
                description: 'Lead quality increased dramatically with human-like text chat filtering, reducing necessity to use other tools for spam detection through AI agentic system.'
            },
            {
                title: 'Native Salesforce Sales Cloud integration',
                description: 'The AI agent builder solution integrated seamlessly with existing Salesforce CRM as a Salesforce bot, enabling both internal sales agents and customers to get personalized recommendations via preferred channels (text messages, emails or interactive voice/text conversation).'
            }
        ]
    }
];

export default function CaseStudies() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const currentCase = caseStudies[currentSlide];

    return (
        <Box id="case-studies" sx={{ py: { xs: 6, md: 10 }, bgcolor: 'white' }}>
            <Container maxWidth="lg">
                <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
                    <Grid size={{ xs: 12, md: 5 }}>
                        <Box sx={{ position: 'relative' }}>
                            <Box
                                sx={{
                                    width: '100%',
                                    height: { xs: 300, md: 400 },
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    position: 'relative'
                                }}
                            >
                                <Box
                                    component="img"
                                    src={currentCase.image}
                                    alt="Case Study"
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                    }}
                                />
                            </Box>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12, md: 7 }}>
                        <Box sx={{ pl: { xs: 0, md: 4 } }}>
                            <Box sx={{ mb: { xs: 3, md: 4 } }}>
                                <Typography
                                    variant="h3"
                                    fontWeight="bold"
                                    sx={{
                                        fontSize: { xs: '29px', md: '40px' },
                                        color: '#1e293b',
                                        mb: 1,
                                        lineHeight: 1.2
                                    }}
                                >
                                    AI Digital Clone Success Story
                                </Typography>
                                <Typography
                                    variant="h6"
                                    sx={{
                                       fontSize: { xs: '22px', md: '19px' },
                                        fontWeight: 800,
                                        mb: 3
                                    }}
                                >
                                    Personalization with AI Agent in Real Estate
                                </Typography>
                            </Box>

                            <Box sx={{ mb: 2 }}>
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    sx={{
                                        color: '#1e293b',
                                        fontSize: { xs: '18x', md: '21px' }
                                    }}
                                >
                                    Client
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: '#64748b',
                                        fontSize: '16px'
                                    }}
                                >
                                    {currentCase.client}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    sx={{
                                        color: '#1e293b',
                                         fontSize: { xs: '18x', md: '21px' },
                                        mb: 2
                                    }}
                                >
                                    Results
                                </Typography>

                                {currentCase.results.map((result, index) => (
                                    <Box key={index} sx={{ mb: 2 }}>
                                        <Typography
                                            variant="subtitle1"
                                            fontWeight="bold"
                                            sx={{
                                                color: '#1e293b',
                                                fontSize: { xs: '16px', md: '18px' }
                                            }}
                                        >
                                            {result.title}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: '#64748b',
                                                fontSize: { xs: '14px', md: '16px' },
                                                lineHeight: 1.5
                                            }}
                                        >
                                            {result.description}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}